import { render, staticRenderFns } from "./GSR.vue?vue&type=template&id=0c904fe3"
import script from "./GSR.vue?vue&type=script&lang=js"
export * from "./GSR.vue?vue&type=script&lang=js"
import style0 from "./GSR.vue?vue&type=style&index=0&id=0c904fe3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports